let videoElements = Array.from(document.querySelectorAll('[data-qplayer-media-id]'));
let scenarioElements = Array.from(document.querySelectorAll('[data-qplayer-scenario-id]'));
let url = document.createElement('a');
url.href = document.getElementById('qplayer').src;

// Production link
let urlTempBase =
  window.location.host === 'alpha-video.qbrick.com' ||
  window.location.host.includes('localhost') ||
  window.location.host === 'p1-video.qbrick.com' ||
  window.location.href.includes('test=true')
    ? 'https://play2.qbrick.com/qplayer-beta'
    : 'https://play2.qbrick.com/qplayer';

const publicApiUrl = 'https://video.qbrick.com/api/v1/public/accounts/';

[...videoElements, ...scenarioElements].map((el) => {
  renderInteractivePlayer(el, urlTempBase);
});

function initiateInteractivePlayer() {
  let videoElems = Array.from(document.querySelectorAll('[data-qplayer-media-id]'));
  let playlistElems = Array.from(document.querySelectorAll('[data-qplayer-playlist-id]'));
  let scenarioElems = Array.from(document.querySelectorAll('[data-qplayer-scenario-id]'));
  [...videoElems, ...playlistElems, ...scenarioElems].map((el) => {
    renderInteractivePlayer(el, urlTempBase);
  });
}

function killInteractivePlayer() {
  let elem = document.querySelectorAll('.qbrick-modal-visible');
  elem.forEach((el) => {
    el.remove();
  });
}

function generateUUID() {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function replaceCharacter(c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function loadjscssfile(filename, filetype) {
  if (filetype == 'js') {
    //if filename is a external JavaScript file
    var fileref = document.createElement('script');
    fileref.setAttribute('type', 'text/javascript');
    fileref.setAttribute('src', filename);
  } else if (filetype == 'css') {
    //if filename is an external CSS file
    var fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', filename);
  }
  if (typeof fileref != 'undefined') {
    document.getElementsByTagName('head')[0].appendChild(fileref);
  }
}

function isMobile() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

function addNoZoomMeta() {
  let meta = document.createElement('meta');
  meta.name = 'viewport';
  meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0';
  meta.setAttribute('data-qplayer-meta-name', 'companion');
  document.getElementsByTagName('head')[0].appendChild(meta);
}

function removeNoZoomMeta() {
  if (document.querySelector("[data-qplayer-meta-name='companion']")) {
    document.querySelector("[data-qplayer-meta-name='companion']").remove();
  }
}

function handlePlay(modalId, shoppingModalContentWrapper, ifrm) {
  shoppingModalContentWrapper.appendChild(ifrm);

  if (isMobile()) {
    document.body.style.top = -1 * window.scrollY + 'px';
    setTimeout(() => (document.body.style.position = 'fixed'));
  } else {
    document.body.classList.add('modal-open');
    document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
  }

  if (!document.querySelector('[data-qplayer-modal-id="' + modalId + '"]').classList.contains('qbrick-modal-visible-minimized')) {
    addNoZoomMeta();
    document.body.style.overflowY = 'hidden';

    setTimeout(function () {
      ifrm.contentWindow.focus();
      ifrm.contentWindow.postMessage(
        {
          origin: 'Qbrick.Shopping.Companion.Loader',
          identifier: 'qbrick-interactive-player-loader',
          command: 'play',
        },
        '*'
      );
      document
        .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qplayer-iframe')[0]
        .classList.add('qplayer-iframe-visible');
      document
        .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .classList.add('qbrick-modal-content-wrapper-visible');
      document
        .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
        .getElementsByClassName('qbrick-modal-content')[0]
        .classList.add('qbrick-modal-content-visible');
      const screenSizeClassName = getScreenSizeName();
      document.querySelector('[data-qplayer-modal-id="' + modalId + '"]').classList.add('qbrick-modal-visible');
      document.querySelector('.qbrick-modal-content-wrapper').classList.add(screenSizeClassName);
    }, 0);
  }
}

function handleMinimize() {
  const visibleModal = document.getElementsByClassName('qbrick-modal-visible')[0];
  if (!visibleModal) {
    return;
  }

  let ifrm = visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    .getElementsByClassName('qplayer-iframe')[0];
  if (visibleModal.classList.contains('qbrick-modal-visible-minimized')) {
    if (isMobile()) {
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
        .classList.remove('qbrick-hide-element');
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
        .classList.remove('qbrick-minimized-overlay-qplayer-modal-hidden');
    }

    document.body.style.overflowY = 'hidden';
    addNoZoomMeta();
    visibleModal.classList.remove('qbrick-modal-visible-minimized');
    visibleModal.getElementsByClassName('qbrick-modal-content')[0].classList.remove('qbrick-modal-content-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .classList.remove('qbrick-modal-content-wrapper-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qplayer-iframe')[0]
      .classList.remove('qplayer-iframe-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
      .classList.remove('qbrick-minimize-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-close-qplayer-modal')[0]
      .classList.remove('qbrick-close-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
      .classList.remove('qbrick-play-pause-qplayer-modal-minimized');

    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
      .classList.remove('qbrick-hide-element-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-close-qplayer-modal')[0]
      .classList.remove('qbrick-hide-element-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
      .classList.remove('qbrick-hide-element-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
      .classList.remove('qbrick-minimized-overlay-qplayer-modal-visible');

    ifrm.contentWindow.postMessage(
      {
        origin: 'Qbrick.Shopping.Companion.Loader',
        identifier: 'qbrick-interactive-player-loader',
        command: 'maximize',
      },
      '*'
    );
  } else {
    if (isMobile()) {
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
        .classList.add('qbrick-hide-element');
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
        .classList.add('qbrick-minimized-overlay-qplayer-modal-hidden');
    }

    document.body.style.overflowY = 'scroll';
    removeNoZoomMeta();
    visibleModal.classList.add('qbrick-modal-visible-minimized');
    visibleModal.getElementsByClassName('qbrick-modal-content')[0].classList.add('qbrick-modal-content-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .classList.add('qbrick-modal-content-wrapper-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qplayer-iframe')[0]
      .classList.add('qplayer-iframe-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
      .classList.add('qbrick-minimize-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-close-qplayer-modal')[0]
      .classList.add('qbrick-close-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
      .classList.add('qbrick-play-pause-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
      .classList.remove('qbrick-minimized-overlay-qplayer-modal-visible');

    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
      .classList.add('qbrick-hide-element-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-close-qplayer-modal')[0]
      .classList.add('qbrick-hide-element-minimized');
    if (
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0].src ===
      urlTempBase + '/assets/pause.svg'
    ) {
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
        .classList.add('qbrick-hide-element-minimized');
    }

    ifrm?.contentWindow?.postMessage(
      {
        origin: 'Qbrick.Shopping.Companion.Loader',
        identifier: 'qbrick-interactive-player-loader',
        command: 'minimize',
      },
      '*'
    );
  }
}

function handlePlayPauseMini(urlTempBase) {
  const visibleModal = document.getElementsByClassName('qbrick-modal-visible')[0];
  if (!visibleModal) {
    return;
  }

  let currentButton = visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0];
  let ifrm = visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    .getElementsByClassName('qplayer-iframe')[0];

  if (currentButton?.src === urlTempBase + '/loader/assets/play.svg') {
    ifrm?.contentWindow?.postMessage(
      {
        origin: 'Qbrick.Shopping.Companion.Loader',
        identifier: 'qbrick-interactive-player-loader',
        command: 'play-minimized',
      },
      '*'
    );
  } else {
    ifrm?.contentWindow?.postMessage(
      {
        origin: 'Qbrick.Shopping.Companion.Loader',
        identifier: 'qbrick-interactive-player-loader',
        command: 'pause',
      },
      '*'
    );
  }
}

function handleCloseModal(element) {
  const visibleModal = document.getElementsByClassName('qbrick-modal-visible')[0];

  if (!visibleModal) {
    return;
  }

  if (isMobile()) {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
  document.body.classList.remove('modal-open');
  document.getElementsByTagName('html')[0].style.overflowY = '';

  removeNoZoomMeta();
  visibleModal.classList.remove('qbrick-modal-visible');
  visibleModal.getElementsByClassName('qbrick-modal-content')[0].classList.remove('qbrick-modal-content-visible');
  visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    ?.classList.remove('qbrick-modal-content-wrapper-visible');
  visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    .getElementsByClassName('qplayer-iframe')[0]
    ?.classList.remove('qplayer-iframe-visible');
  document.body.style.overflowY = 'scroll';

  if (visibleModal.classList.contains('qbrick-modal-visible-minimized')) {
    visibleModal.classList.remove('qbrick-modal-visible-minimized');
    visibleModal.getElementsByClassName('qbrick-modal-content')[0].classList.remove('qbrick-modal-content-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .classList.remove('qbrick-modal-content-wrapper-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qplayer-iframe')[0]
      .classList.remove('qplayer-iframe-visible-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
      .classList.remove('qbrick-minimize-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-close-qplayer-modal')[0]
      .classList.remove('qbrick-close-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
      .classList.remove('qbrick-hide-element-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
      .classList.remove('qbrick-play-pause-qplayer-modal-minimized');
    visibleModal
      .getElementsByClassName('qbrick-modal-content')[0]
      .getElementsByClassName('qbrick-modal-content-wrapper')[0]
      .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
      .classList.remove('qbrick-minimized-overlay-qplayer-modal-visible');
    if (isMobile()) {
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
        .classList.remove('qbrick-minimized-overlay-qplayer-modal-hidden');
      visibleModal
        .getElementsByClassName('qbrick-modal-content')[0]
        .getElementsByClassName('qbrick-modal-content-wrapper')[0]
        .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
        .classList.remove('qbrick-hide-element');
    }
  }

  const modalBtn = element.getElementsByClassName('qplayer__play-btn')[0];
  if (modalBtn) {
    modalBtn.focus();
  }

  const ifrm = visibleModal
    .getElementsByClassName('qbrick-modal-content')[0]
    .getElementsByClassName('qbrick-modal-content-wrapper')[0]
    .getElementsByClassName('qplayer-iframe')[0];
  ifrm?.contentWindow?.postMessage(
    {
      origin: 'Qbrick.Shopping.Companion.Loader',
      identifier: 'qbrick-interactive-player-loader',
      command: 'pause',
    },
    '*'
  );
  ifrm?.contentWindow?.postMessage(
    {
      origin: 'Qbrick.Shopping.Companion.Loader',
      identifier: 'qbrick-interactive-player-loader',
      command: 'close-modal',
    },
    '*'
  );
}

loadjscssfile(urlTempBase + '/loader/qplayer-loader.css', 'css');

function getRestrictToken(mediaId, tokens, isScenario = false) {
  let result = null;
  const splitter = isScenario ? '-scenario-' : '-media-';

  if (tokens && tokens.length > 0) {
    tokens.forEach((token) => {
      const checks = token.split(splitter);
      result = token.includes(mediaId) ? checks[0] : null;
    });
  }

  return result;
}

function getThumbnailFromHomeScene(scenarioId, accountId, modalId, tokens) {
  const url = publicApiUrl + accountId + '/scenarios/' + scenarioId;
  const token = getRestrictToken(scenarioId, tokens, true);
  const headers = token
    ? {
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': 'AVP1 ' + token,
      },
    }
    : undefined;

  fetch(url, headers)
    .then((res) => res.json())
    .then((scenario) => {
      if (!scenario || typeof scenario === 'string') {
        return;
      }

      let bgMediaId = '';
      const homeScene = (scenario.scenes ?? []).find((scene) => scene.id === (scenario.defaults ?? {}).sceneId);
      const widgetTemplates = homeScene?.widgetTemplates ?? [];
      let currentLayout = (homeScene?.layouts ?? []).find((l) => l.type === (scenario?.defaults?.type ?? 'desktop')) ?? {};
      currentLayout = currentLayout ?? homeScene?.layouts?.[0] ?? {};
      const backgroundWidgets = (currentLayout?.boxes ?? [])?.[0]?.widgets ?? [];

      widgetTemplates.forEach((template) => {
        if (backgroundWidgets.find((bg) => bg?.widgetTemplateId === template?.id)) {
          if (template?.type === 'video') {
            bgMediaId = template?.settings?.mediaId;
          }
        }
      });

      if (!bgMediaId) {
        return;
      }
      setThumbnail(bgMediaId, accountId, modalId);
    });
}

function setThumbnail(mediaId, accountId, modalId, tokens) {
  let dataUrl = publicApiUrl + accountId + '/medias/' + mediaId;
  const token = getRestrictToken(mediaId, tokens, false);
  const headers = token
    ? {
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': 'AVP1 ' + token,
      },
    }
    : undefined;

  fetch(dataUrl, headers)
    .then((res) => res.json())
    .then((data) => {
      if (!data || typeof data === 'string') {
        return;
      }

      let thumbnailElement = data.asset?.resources?.filter((el) => el.type === 'image');
      let thumbnailUrl = thumbnailElement[0].renditions[0].links[0].href;
      const modal = document.querySelector('[data-qplayer-start-modal-id="' + modalId + '"]');
      if (modal) {
        modal.style.backgroundImage = 'url("' + thumbnailUrl + '")';
      }
    });
}

function renderInteractivePlayer(element, urlBase) {
  let mediaId = element.getAttribute('data-qplayer-media-id');
  let playlistId = element.getAttribute('data-qplayer-playlist-id');
  let modalId = element.getAttribute('data-qplayer-id') ?? generateUUID();
  let scenarioId = element.getAttribute('data-qplayer-scenario-id');
  let accountId = element.getAttribute('data-qplayer-account-id');
  let configId = element.getAttribute('data-qplayer-preset-id');
  let isItInline = element.getAttribute('data-qplayer-inline') ?? 'on';
  let autoplayData = element.getAttribute('data-qplayer-autoplay');
  let autoplayValue = autoplayData === null ? '' : '&autoplay=' + autoplayData;
  let sharingData = element.getAttribute('data-qplayer-sharing');
  let sharingValue = sharingData === null ? '' : '&sharing=' + sharingData;
  let muteData = element.getAttribute('data-qplayer-mute');
  let muteValue = muteData === null ? '' : '&mute=' + muteData;
  let repeatData = element.getAttribute('data-qplayer-repeat');
  let repeatValue = repeatData === null ? '' : '&repeat=' + repeatData;
  let downloadData = element.getAttribute('data-qplayer-download');
  let downloadValue = downloadData === null ? '' : '&download=' + downloadData;
  let thumbnailMediaId = element.getAttribute('data-qplayer-thumbnail-media-id');
  let analytics = element.getAttribute('data-qplayer-analytics');
  let uniqueFrame = element.getAttribute('data-qplayer-unique-frame');
  let tokenElems = document.querySelectorAll('[data-qplayer-token]');
  let playerTitle = 'QPlayer' + (element.getAttribute('title') ? ' - ' + element.getAttribute('title') : '');

  const isTesting = element.getAttribute('data-qplayer-test') === 'true' || window.location.href.includes('test=true') ? true : false;
  const urlTempBase = isTesting ? 'https://play2.qbrick.com/qplayer-beta' : urlBase;

  let tokens = [];
  if (tokenElems.length > 0) {
    tokenElems.forEach((elem) => {
      let token = elem.getAttribute('data-qplayer-token');
      tokens.push(token);
    });
  }

  let preURL = '/index.html?mediaId=' + mediaId;
  if (playlistId) {
    preURL = '/index.html?playlistId=' + playlistId;
  }
  if (scenarioId) {
    preURL = '/index.html?scenarioId=' + scenarioId;
  }

  // const preURL = mediaId ? 'http://localhost:3000/q?mediaId=' + mediaId : 'http://localhost:3000/q?scenarioId=' + scenarioId;
  let iframeUrl =
    urlTempBase +
    preURL +
    '&accountId=' +
    accountId +
    '&configId=' +
    configId +
    '&useLoader=true' +
    autoplayValue +
    sharingValue +
    muteValue +
    repeatValue +
    downloadValue +
    (isItInline === null ? '' : '&inline=' + isItInline) +
    (thumbnailMediaId === null ? '' : '&thumbnailMediaId=' + thumbnailMediaId) +
    (analytics === null ? '' : '&ignoreAnalytics=' + (analytics === 'off' ? 'true' : 'false')) +
    (uniqueFrame === null ? '' : '&uniqueFrame=' + uniqueFrame);

  const ifrm = document.createElement('iframe');
  ifrm.setAttribute('id', 'iframe' + modalId);
  ifrm.setAttribute('title', playerTitle);
  const tokenData = {
    type: 'qplayer_tokens',
    tokens: tokens,
  };

  if (ifrm?.contentWindow?.document?.readyState === 'complete') {
    setTimeout(() => {
      ifrm?.contentWindow.postMessage(tokenData, '*');
    }, 100);
  } else {
    ifrm?.addEventListener('load', () =>
      setTimeout(() => {
        ifrm?.contentWindow.postMessage(tokenData, '*');
      }, 100)
    );
  }

  if (isItInline === 'on') {
    ifrm.classList.add('qplayer-iframe-inline');
    ifrm.setAttribute('src', iframeUrl);
    ifrm.setAttribute('frameBorder', '0');
    ifrm.setAttribute('allow', 'fullscreen');
    element.appendChild(ifrm);

    if (element.hasAttribute('data-qplayer-thumbnail-width')) {
      element.style.width = element.getAttribute('data-qplayer-thumbnail-width');
    } else {
      element.style.width = '100%';
    }

    if (element.hasAttribute('data-qplayer-thumbnail-height')) {
      element.style.height = element.getAttribute('data-qplayer-thumbnail-height');
    } else {
      element.style.height = '100%';
    }
  } else {
    if (!element.hasAttribute('data-qplayer-custom-button') && !element.getAttribute('data-qplayer-custom-button') === true) {
      element.classList.add('qplayer__button-standard-thumbnail');

      if (element.hasAttribute('data-qplayer-thumbnail-width')) {
        element.style.width = element.getAttribute('data-qplayer-thumbnail-width');
      } else {
        element.style.width = '100%';
      }

      if (element.hasAttribute('data-qplayer-thumbnail-height')) {
        element.style.height = element.getAttribute('data-qplayer-thumbnail-height');
      } else {
        element.style.height = '100%';
      }

      let shoppingButtonWrapper = document.createElement('div');
      shoppingButtonWrapper.classList.add('qplayer__button-open-modal-wrapper');
      shoppingButtonWrapper.setAttribute('data-qplayer-start-modal-id', modalId);
      element.appendChild(shoppingButtonWrapper);

      let shoppingButton = document.createElement('div');
      shoppingButton.classList.add('qplayer__play-btn');
      shoppingButton.setAttribute('role', 'button');
      shoppingButton.ariaLabel = 'Open';
      shoppingButton.setAttribute('tabindex', '0');
      shoppingButtonWrapper.appendChild(shoppingButton);

      let shoppingButtonWrapperSvg = document.createElement('img');
      shoppingButtonWrapperSvg.classList.add('qplayer__play-img');
      shoppingButtonWrapperSvg.src = urlTempBase + '/loader/assets/play-button.svg';
      shoppingButtonWrapperSvg.ariaHidden = 'true';
      shoppingButton.appendChild(shoppingButtonWrapperSvg);

      if (thumbnailMediaId) {
        setThumbnail(thumbnailMediaId, accountId, modalId, tokens);
      } else if (scenarioId) {
        getThumbnailFromHomeScene(scenarioId, accountId, modalId, tokens);
      } else {
        setThumbnail(mediaId, accountId, modalId, tokens);
      }
    }

    let shoppingModal = document.createElement('div');
    shoppingModal.classList.add('qbrick-modal');
    shoppingModal.setAttribute('data-qplayer-modal-id', modalId);

    let shoppingModalContent = document.createElement('div');
    shoppingModalContent.classList.add('qbrick-modal-content');
    shoppingModal.appendChild(shoppingModalContent);

    let shoppingModalContentWrapper = document.createElement('div');
    shoppingModalContentWrapper.classList.add('qbrick-modal-content-wrapper');
    shoppingModalContent.appendChild(shoppingModalContentWrapper);

    // TEMPORARY REMOVE SINCE NOT SUPPORT PICTURE-IN-PICTURE yet
    // let minimizeModal = document.createElement("img");
    // minimizeModal.src = urlTempBase + '/loader/assets/minimize.svg';
    // minimizeModal.classList.add('qbrick-minimize-qplayer-modal');
    // shoppingModalContentWrapper.appendChild(minimizeModal);

    let closeImg = document.createElement('img');
    closeImg.src = urlTempBase + '/loader/assets/x.svg';
    closeImg.ariaHidden = 'true';
    let closeModal = document.createElement('div');
    closeModal.classList.add('qbrick-close-qplayer-modal');
    closeModal.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16.191" height="16.191" viewBox="0 0 16.191 16.191"><defs><style>.a{fill:#fff;fill-rule:evenodd;}</style></defs><path class="a" d="M19.893,4.3a1.012,1.012,0,0,1,0,1.433L5.729,19.893A1.013,1.013,0,1,1,4.3,18.461L18.46,4.3a1.012,1.012,0,0,1,1.433,0Z" transform="translate(-3.999 -3.999)"/><path class="a" d="M4.3,4.3a1.012,1.012,0,0,0,0,1.433L18.461,19.893a1.013,1.013,0,1,0,1.433-1.433L5.729,4.3A1.012,1.012,0,0,0,4.3,4.3Z" transform="translate(-3.999 -3.999)"/></svg>`;
    closeModal.setAttribute('role', 'button');
    closeModal.ariaLabel = 'Close';
    shoppingModalContentWrapper.appendChild(closeModal);

    let playPauseMiniModal = document.createElement('img');
    playPauseMiniModal.src = urlTempBase + '/loader/assets/pause.svg';
    playPauseMiniModal.classList.add('qbrick-play-pause-qplayer-modal');
    playPauseMiniModal.ariaHidden = 'true';
    shoppingModalContentWrapper.appendChild(playPauseMiniModal);

    let minimizedOverlay = document.createElement('div');
    minimizedOverlay.classList.add('qbrick-minimized-overlay-qplayer-modal');
    shoppingModalContentWrapper.appendChild(minimizedOverlay);

    minimizedOverlay.onclick = function () {
      if (isMobile()) {
        handleMinimize();
        document.body.style.position = '';
        document.body.style.top = '';
      }
    };

    ifrm.classList.add('qplayer-iframe');
    ifrm.setAttribute('src', iframeUrl);
    ifrm.setAttribute('allow', 'autoplay; fullscreen');

    document.body.insertBefore(shoppingModal, document.body.firstChild);

    element.onclick = function () {
      handlePlay(modalId, shoppingModalContentWrapper, ifrm);
    };
    element.onkeyup = function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handlePlay(modalId, shoppingModalContentWrapper, ifrm);
      }
    };

    closeModal.onclick = function () {
      setTimeout(() => handleCloseModal(element), 300);
    };

    // Click outside player, close it!
    shoppingModalContentWrapper.setAttribute('title', 'Click to close player.');
    shoppingModalContentWrapper.onclick = function (e) {
      if (e.target.classList.contains('qbrick-modal-content-wrapper')) {
        setTimeout(() => handleCloseModal(element), 300);
      }
    };

    // minimizeModal.onclick = function () {
    //     handleMinimize(mediaId);
    // };

    playPauseMiniModal.onclick = function () {
      handlePlayPauseMini(urlTempBase);
    };

    shoppingModal.onclick = function (event) {
      if (event.target.className === 'qbrick-modal qbrick-modal-visible') {
        ifrm.contentWindow.postMessage(
          {
            origin: 'Qbrick.Shopping.Companion.Loader',
            identifier: 'qbrick-interactive-player-loader',
            command: 'pause',
          },
          '*'
        );
        ifrm.contentWindow.postMessage(
          {
            origin: 'Qbrick.Shopping.Companion.Loader',
            identifier: 'qbrick-interactive-player-loader',
            command: 'close-modal',
          },
          '*'
        );

        setTimeout(() => {
          removeNoZoomMeta();
          document.querySelector('[data-qplayer-modal-id="' + modalId + '"]').classList.remove('qbrick-modal-visible');
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .classList.remove('qbrick-modal-content-visible');
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .classList.remove('qbrick-modal-content-wrapper-visible');
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qplayer-iframe')[0]
            .classList.remove('qplayer-iframe-visible');
          document.body.style.overflowY = 'scroll';
          if (isMobile()) {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
          }
          document.body.classList.remove('modal-open');
          document.getElementsByTagName('html')[0].style.overflowY = '';
        }, 100);
      }
    };

    shoppingModal.addEventListener('mouseover', () => {
      if (shoppingModal.classList.contains('qbrick-modal-visible-minimized')) {
        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
          .classList.add('qbrick-minimized-overlay-qplayer-modal-visible');
        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
          .classList.remove('qbrick-hide-element-minimized');
        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-close-qplayer-modal')[0]
          .classList.remove('qbrick-hide-element-minimized');
        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
          .classList.remove('qbrick-hide-element-minimized');
      }
    });

    shoppingModal.addEventListener('mouseout', () => {
      if (shoppingModal.classList.contains('qbrick-modal-visible-minimized')) {
        if (
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0].src ===
          urlTempBase + '/loader/assets/pause.svg'
        ) {
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-minimized-overlay-qplayer-modal')[0]
            .classList.remove('qbrick-minimized-overlay-qplayer-modal-visible');
        }

        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-minimize-qplayer-modal')[0]
          .classList.add('qbrick-hide-element-minimized');
        document
          .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
          .getElementsByClassName('qbrick-modal-content')[0]
          .getElementsByClassName('qbrick-modal-content-wrapper')[0]
          .getElementsByClassName('qbrick-close-qplayer-modal')[0]
          .classList.add('qbrick-hide-element-minimized');
        if (
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0].src ===
          urlTempBase + '/loader/assets/pause.svg'
        ) {
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
            .classList.add('qbrick-hide-element-minimized');
        }
      }
    });

    window.addEventListener('message', (message) => {
      if (message.data.identifier === 'qbrick-modal-handler-event') {
        if (message.data.command.data === 'hide-x-basket') {
          closeModal.classList.add('qbrick-hide-element');
          // minimizeModal.classList.add('qbrick-hide-element');
        }

        if (message.data.command.data === 'show-play') {
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
            .classList.add('qbrick-play-pause-qplayer-modal-minimized');
        }

        if (message.data.command.data === 'hide-play') {
          document
            .querySelector('[data-qplayer-modal-id="' + modalId + '"]')
            .getElementsByClassName('qbrick-modal-content')[0]
            .getElementsByClassName('qbrick-modal-content-wrapper')[0]
            .getElementsByClassName('qbrick-play-pause-qplayer-modal')[0]
            .classList.remove('qbrick-play-pause-qplayer-modal-minimized');
        }

        if (message.data.command.data === 'show-x-basket') {
          closeModal.classList.remove('qbrick-hide-element');
          // minimizeModal.classList.remove('qbrick-hide-element');
        }

        if (message.data.command.data === 'player-play') {
          playPauseMiniModal.src = urlTempBase + '/loader/assets/pause.svg';
        }

        if (message.data.command.data === 'player-pause') {
          playPauseMiniModal.src = urlTempBase + '/loader/assets/play.svg';
        }
      }
    });
  }
}

function getScreenSizeName() {
  const width = window.innerWidth;
  let sizeClassName = 'qplayer-modal-huge';

  if (width <= 430) {
    sizeClassName = 'qplayer-modal-mobile';
  } else if (width <= 600) {
    sizeClassName = 'qplayer-modal-small';
  } else if (width <= 768) {
    sizeClassName = 'qplayer-modal-medium';
  } else if (width <= 1280) {
    sizeClassName = 'qplayer-modal-big';
  }
  return sizeClassName;
}

function onWindowResize() {
  const modalContent = document.querySelector('.qbrick-modal-content-wrapper.qbrick-modal-content-wrapper-visible');
  if (!modalContent) {
    return;
  }
  const sizeClassName = getScreenSizeName();
  modalContent.classList = 'qbrick-modal-content-wrapper qbrick-modal-content-wrapper-visible ' + sizeClassName;
}

window.onresize = onWindowResize;